import PrimaryDefaultButton from '@/components/buttons/primary/DefaultButton';
import { COLORS } from '@/styles/color';
import styled from 'styled-components';

const SecondaryDefaultButton = styled(PrimaryDefaultButton)`
  background-color: transparent;
  border: 1px solid;
  border-color: var(--button-color, ${COLORS.VIOLET.LOWLIGHT});
  color: var(--button-text-color, ${COLORS.VIOLET.LOWLIGHT});

  &:hover {
    border-color: var(--button-color-hover, ${COLORS.VIOLET.LOWLIGHT});
    background-color: var(--button-color-hover, ${COLORS.VIOLET.LOWLIGHT});
    color: var(--button-text-color-hover, ${COLORS.WHITE});
  }
`;

export default SecondaryDefaultButton;
